import { FormControl } from "@mui/material";
import {
  DatePicker,
  DatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";
import { Calendar1Icon } from "./Icons";

interface GKDatePickerProps {
  inputLabel?: string;
  id?: string;
  name?: string;
  requiredField?: boolean;
  disableToday?: boolean;
}

const GKDatePicker = (props: GKDatePickerProps & DatePickerProps<any>) => {
  const {
    inputLabel,
    requiredField,
    disableToday = false,
    minDate,
    ...rest
  } = props;

  return (
    <FormControl variant="standard" fullWidth sx={{ mt: inputLabel ? 0.7 : 0 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          {...rest}
          label={inputLabel}
          slots={{
            ...props?.slots,
            openPickerIcon: Calendar1Icon,
          }}
          slotProps={{
            ...props.slotProps,
            openPickerIcon: {
              ...props?.slotProps?.openPickerIcon,
              fontSize: 20,
              color: "var(--neutral-500)",
            },
            textField: {
              ...props?.slotProps?.textField,
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
                "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
                  borderRadius: "8px",
                },
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                  marginRight: 0,
                },
              },
            },
          }}
          minDate={minDate || dayjs("01-01-1980")}
          format="DD-MM-YYYY"
          shouldDisableDate={(date: any) =>
            disableToday ? date.isSame(dayjs(), "day") : ""
          }
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default GKDatePicker;
